<template>
  <masonry class="masonry" :cols="{ default: 4, 1903: 3, 1263: 2, 960: 1 }" :gutter="{ default: '10px', 800: '5px' }" :style="`margin-bottom:62px`">
    <div class="item" v-for="(widget, ind) in viewConfig.widgets" :key="ind">
      <widget :config="enhanceConfig(widget, ind)"></widget>
    </div>
  </masonry>
</template>
<script>
import Widget from '@/view-widgets/Widget';
import common from '@/mixins/common';
export default {
  name: 'MasonryView',
  mixins: [common],
  components: {
    Widget,
  },

  methods: {
    enhanceConfig(config, index) {
      if (this.$route.meta.configIdentifier) {
        const { idPath } = this.$route.meta.configIdentifier;
        return { configId: `${idPath}/${index}`, ...config };
      }
      return config;
    },
  },
  computed: {
    viewConfig() {
      return this.$route.meta.viewConfig;
    },
  },
};
</script>
